<template>
        <div class="form-success tw-container tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full">
            <div class="tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full">
                <h3 class="tw-py-3 tw-uppercase">{{ $t ('page.successMessage.title')}}</h3>
                <p>
                    {{ $t ('page.successMessage.mainText')}}<br>
                    <i18n path="page.successMessage.middleText" tag="span" for="page.successMessage.link">
                        <a v-bind:href="`/PDF/${$t('page.successMessage.caseStudy')}.pdf`" download><u>{{ $t('page.successMessage.link') }}</u></a>
                    </i18n>
                    <br>
                    {{ $t ('page.successMessage.lastText')}}
                </p>
            </div>
        </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>